
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UnitPipe } from './unit.pipe';

@NgModule({
    imports: [
        TranslateModule,
    ],
    exports: [
        UnitPipe,
    ],
    declarations: [
        UnitPipe,
    ],
    providers: [
        UnitPipe
    ],
})
export class SharedUnitPipeModule {}
